/** A source of numbers in `[0, 1)`, like `Math.random`. Injectable so game logic that depends on randomness (CHAOS outcomes, bite placement) can be tested deterministically. */
export type RandomSource = () => number;

/**
 * Small, fast, seedable PRNG (mulberry32). Deterministic for a given seed,
 * so tests and a future Daily Challenge mode can reproduce an exact run.
 */
export function createSeededRandom(seed: number): RandomSource {
  let state = seed >>> 0;
  return function random(): number {
    state |= 0;
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Builds a `RandomSource` that always returns the given fixed values in order, looping once exhausted. Handy for tests that need to force a specific outcome. */
export function createScriptedRandom(values: readonly number[]): RandomSource {
  let index = 0;
  return () => {
    const value = values[index % values.length];
    index++;
    return value;
  };
}
